import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment } from '@angular/router';

/** Sub-routes owned by root CryptoWillModule (logged-in will wizard). */
const ROOT_CRYPTO_WILL_PATH = /^crypto-will\/(will|list|print)(\/|$)/;

@Injectable({ providedIn: 'root' })
export class PublicCryptoWillGuard implements CanMatch {
  canMatch(_route: Route, segments: UrlSegment[]): boolean {
    const path = segments.map((segment) => segment.path).join('/');
    return !ROOT_CRYPTO_WILL_PATH.test(path);
  }
}
